import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Organicé toda mi planificación en un fin de semana. Ahora sé exactamente qué hacer cada día para tener un topspin consistente. Nunca más voy al club a pelotear improvisando a ver qué sale.',
  name: 'Tomás M.',
  location: 'Buenos Aires',
  type: 'Jugador de Club Intermedio'
}, {
  quote: 'El checklist de reparación técnica cambió todo. Logré corregir mi golpe de derecha en medio de un partido después de estar meses fallando a la red. Y al fin entiendo cómo aprovechar mis gomas europeas.',
  name: 'Ignacio R.',
  location: 'Rosario',
  type: 'Estilo Ofensivo Allround'
}, {
  quote: 'Adapto mi estrategia según el oponente en solo 5 minutos. Antes me llevaba horas ver videos en YouTube tratando de entender por qué perdía puntos tontos en el tercer set.',
  name: 'Valentina F.',
  location: 'Córdoba',
  type: 'Jugadora Competitiva'
}];
export function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollRef = useRef<HTMLDivElement>(null);
  const handleScroll = () => {
    if (scrollRef.current) {
      const scrollLeft = scrollRef.current.scrollLeft;
      const width = scrollRef.current.offsetWidth;
      setActiveIndex(Math.round(scrollLeft / width));
    }
  };
  return <section className="py-10 sm:py-14 bg-navy-800 border-y border-navy-700 overflow-hidden" data-id="element-271">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-272">
        {/* Mobile Carousel / Desktop Grid */}
        <div ref={scrollRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory hide-scrollbar md:grid md:grid-cols-3 gap-4 md:gap-8 pb-4 md:pb-0" data-id="element-273">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.15
        }} className="bg-navy-900 p-4 sm:p-6 rounded-xl border border-navy-700 flex flex-col h-full relative min-w-[85%] sm:min-w-[60%] md:min-w-0 snap-center shrink-0" data-id="element-274">
              <div className="absolute -top-2 left-4 sm:-top-3 sm:left-6 text-3xl sm:text-4xl text-gold-500/20 font-display" data-id="element-275">
                "
              </div>
              <div className="flex gap-1 mb-3 sm:mb-4" data-id="element-276">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-gold-400 fill-gold-400" data-id="element-277" />)}
              </div>
              <p className="text-offwhite italic mb-4 sm:mb-6 flex-grow relative z-10 text-sm leading-relaxed" data-id="element-278">
                "{t.quote}"
              </p>
              <div className="mt-auto pt-3 sm:pt-4 border-t border-navy-700/50" data-id="element-279">
                <p className="font-bold text-gold-400 text-sm sm:text-base" data-id="element-280">
                  {t.name}
                </p>
                <p className="text-[10px] sm:text-xs text-text-secondary" data-id="element-281">
                  {t.location} — {t.type}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Mobile Dots Indicator */}
        <div className="flex justify-center gap-2 mt-2 md:hidden" data-id="element-282">
          {testimonials.map((_, i) => <div key={i} className={`h-1.5 rounded-full transition-all duration-300 ${activeIndex === i ? 'w-6 bg-gold-500' : 'w-1.5 bg-navy-700'}`} data-id="element-283" />)}
        </div>
      </div>
    </section>;
}